import * as apiEndpoints from'./apiEndpoints'
import { apiCaller } from './apiCaller'

export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

const ACCOUNT = 'accounts';
const PAYMENT = 'payments'
const POCKET = 'pocket'
const INFORMATION_PORTAL = 'ip'
const PUBLICATION = 'pb'
const COLLECTION = 'collection'
const DOSSIER = 'dossier'
const ANALYTICS_MANUAL = 'am'
const CURATE_EXT = 'curate-ext'
const ADMIN = 'admin'
const ADMIN_EXT = 'admin_ext'
const USER = 'user'
const AUTHOR = 'au'
const PUBLISHER = 'pr'
const SOCIAL = 'social'
const CONTENT = 'content'
const ADMIN_CURATE = 'admin-curate'
const INSIGHT = 'insight'
const TWITTER = 'twitter'
const FACEBOOK = 'facebook'
const SHORT = 's'
const SHORT_URL = 'short_url'
const NEWSROOM = 'newsroom'
const EMBEDDABLE = 'tp'
const ORGANISATION = 'org'
const PEOPLE = 'people'
const TEAM = 'team'
const ORGANISATION_BILLING= 'org-billing'
const DONATION = 'donation'
const DONATION_EXT = 'donation-ext'
const COLLABORATORS = 'collab'
const TEAM_EXTENSION = 'team-ext'
const ORGANISATION_PERMISSIONS = 'org-per'
const DOMAIN = 'domain'
const LOCATION = 'loc'
const ORGANISATION_LICENSE= 'org-lic'
const IAM = 'iam'
const IAM_PERMISSIONS = 'iam-policy'
const EDITOR = 'editor'

const METHOD = {
	GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	DELETE: 'DELETE'
  }

// sign up
export function signup (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.signup}`;
	return apiCaller({'method': 'POST', url, body, service: ACCOUNT})
}

// sign in
export function signin (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.signin}`;
	return apiCaller({'method': 'POST', url, body, service: ACCOUNT})
}

// forgotpassword
export function forgotPassword (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.forgotpassword}`;
	return apiCaller({'method': 'POST', url, body, service: ACCOUNT})
}

// resetPassword
export function resetPassword (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.resetPassword}`;
	return apiCaller({'method': 'POST', url, body, service: ACCOUNT})
}

// changePassword
export function changePassword (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.changePassword}`;
	return apiCaller({'method': 'POST', url, body, service: ACCOUNT})
}

// resend verification email
export function resendVerificationEmail (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.resendVerification}`;
	return apiCaller({'method': 'POST', url, body, service: ACCOUNT})
}

// verify email
export function verifiyEmail (query) {
	let url = `${API_BASE_URL}/${ACCOUNT}/verify/${query.type}/email/${query.key}`;
	return apiCaller({'method': 'GET', url, service: ACCOUNT})
}

// to fetch user information
export function getUserProfile (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.userProfile}`;
	return apiCaller({method: METHOD.POST, url, body, service: ACCOUNT})
}

// to update user profile information
export function updateUserProfile (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.updateUserProfile}`;
	return apiCaller({'method': 'PUT', url, body, service: ACCOUNT})
}

// to get the image upload URL form server.
export function getImageUploadURL (query) {
	let url = `${API_BASE_URL}/${ACCOUNT}/${apiEndpoints.getUploadURL}/${query.imageName}`;
	return apiCaller({'method': 'GET', url, service: ACCOUNT})
}

// to upload image on s3 bucket
export function uploadImage (body) {
	let url = body.uploadUrl.uploadUrl;
	return apiCaller({'method': 'PUT', url, body:body.imageData, isImage:true, fileKey: body.uploadUrl.fileKey})
}

// to fetch Stripe CustomerId
export function fetchStripeCustomerId () {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.getStripeCustomerId}`;
	return apiCaller({'method': 'GET', url, service: PAYMENT})
}

// to update update Customer Source/card(credit card) on stripe
export function updatePaymentMethod (body) {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.updatePaymentMethod}`;
	return apiCaller({'method': 'PUT', url, body, service: PAYMENT})
}

// to subscribe a accura plan
export function subscribePlan (body) {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.subscribePlan}`;
	return apiCaller({'method': 'POST', url, body, service: PAYMENT})
}

// to get active subscription of the user
export function getActiveSubscription () {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.subscribePlan}`;
	return apiCaller({'method': 'GET', url, service: PAYMENT})
}

// to get available plans list
export function getAllPlans () {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.getAllPlans}`;
	return apiCaller({'method': 'GET', url, service: PAYMENT})
}

// unsubscribe the active Plan
export function unSubscribePlan (planId) {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.subscribePlan}/${planId}`;
	return apiCaller({'method': 'DELETE', url, service: PAYMENT})
}

// get pocket token for verify
export function verifyPocketCode (body, token) {
	let url = `${API_BASE_URL}/${POCKET}/${apiEndpoints.verifyPocket}`;
	return apiCaller({'method': 'POST', url, body, token, service: POCKET})
}


//Information Portal

//get all following list
export function getAllFollowingList(body, route){
	let params = {
		limit: '30'
	}
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/${'list'}/${route}`
	return apiCaller({method: 'POST', url, body, params, service: INFORMATION_PORTAL})
}

//get detail of author, publication, publisher.
export function getDetails(type, id){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/${type}/${id}`
	return apiCaller({method: 'GET', url, service: INFORMATION_PORTAL})
}

export function followUnfollow(body, action, type){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/${action}/${type}`
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function checkForAdminAccess(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/check-claim`;
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function requestListingAccess(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/request-access`;
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function uniqueListing(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/unique`;
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function createAuthor(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/author`;
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function createPublisher(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/publisher`;
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function createPublication(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/publication`;
	return apiCaller({method: 'POST', url, body, service: INFORMATION_PORTAL})
}

export function updateAuthor(body, authorId){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/author/${authorId}`;
	return apiCaller({method: 'PUT', url, body, service: INFORMATION_PORTAL})
}

export function updatePublisher(body, publisherId){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/publisher/${publisherId}`;
	return apiCaller({method: 'PUT', url, body, service: INFORMATION_PORTAL})
}

export function updatePublication(body, publicationId){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/publication/${publicationId}`;
	return apiCaller({method: 'PUT', url, body, service: INFORMATION_PORTAL})
}

export function getRegisteredList(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/card-list`;
	return apiCaller({method: METHOD.POST,url, body, service: INFORMATION_PORTAL})
}

export function removeAuthorListing(body){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/remove`;
	return apiCaller({method: 'POST',url, body, service: INFORMATION_PORTAL})
}

export function getLanguages(){
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/languages`;
	return apiCaller({method: 'GET',url, service: INFORMATION_PORTAL})
}

/**
 * api call to get the listing article/publisher
 * @param {*} type 
 * @param {*} params 
 */
export function getContentList (type, params, body) {
	let url = `${API_BASE_URL}/${ADMIN}/${type}${params}`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN})
}

// api call to get publiction listing on admin portal
export function getPublicationList (type, params, body) {
	let url = `${API_BASE_URL}/${ADMIN}/${type}${params}`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN})
} 

export function getContent (body) {
	let url = `${API_BASE_URL}/${ADMIN}/${apiEndpoints.getContent}/${body}`
	return apiCaller({method: METHOD.GET, url, service: ADMIN})
}

/**
 * To get the list of A/P/P for admin portal
 * @param {*} body body type will be A/P/P 
 * and body id will be the id for A/P/P
 */
export function getAuthorList (body) {
	let url = `${API_BASE_URL}/${ADMIN}/${body.type}/${body.id}`
	return apiCaller({method: METHOD.GET, url, service: ADMIN})
}

export function getMetaDataList (body) {
	let url = `${API_BASE_URL}/${ADMIN}/${apiEndpoints.getList}`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN})
}

export function updateMetaData (body, params) {
	let url = `${API_BASE_URL}/${ADMIN}/${apiEndpoints.getContent}/${params}`
	return apiCaller({method: METHOD.PUT, url, body, service: ADMIN})
}
export function logoutCall (body) {
	let url = `${API_BASE_URL}/${ACCOUNT}/logout`
	return apiCaller({method: METHOD.POST, url, body, service: ACCOUNT})
}

export function userRights (body) {
	let url = `${API_BASE_URL}/${USER}/meta/user-right`
	return apiCaller({method: METHOD.POST, url, body, service: USER})
}

export function getUsersList (body) {
	let url = `${API_BASE_URL}/${USER}/${apiEndpoints.getList}`
	return apiCaller({method: METHOD.POST, url, body, service: USER})
}

export function editScrapName (body) {
	let url = `${API_BASE_URL}/${ADMIN}/scrap-name`
	return apiCaller({method: METHOD.PUT, url, body, service: ADMIN})
}
export function deleteRegisteredList (body) {
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/card-list`;
	return apiCaller({method: METHOD.DELETE, url, body, service:INFORMATION_PORTAL})
}
/**
 * to update multiple types from admin portal
 * @param {*} type type -> content, author,publisher , publication
 * @param {*} body fields to be updated
 */
export function bulkUpdate (type, body) {
	let url = `${API_BASE_URL}/${ADMIN}/bulk-update/${type}`
	return apiCaller({method: METHOD.PUT, url, body, service: ADMIN})
}
/**
 * api to fetch count of admin menu
 */
export function getAdminMenuCount() {
	let url = `${API_BASE_URL}/${ADMIN}/count`
	return apiCaller({method: METHOD.GET, url, service: ADMIN})
}
//update subscription into db after 3d authentication
export function updateUserPlan (body) {
	let url = `${API_BASE_URL}/${PAYMENT}/${apiEndpoints.userPlan}`;
	return apiCaller({method: 'PUT', url, body, service: PAYMENT})
}

// get subscriptions(users) list
export function getSubscriptions (params, body) {
	let url = `${API_BASE_URL}/${USER}/users${params}`
	return apiCaller({method: METHOD.POST, url, body, service: USER})
}
export function publicationFieldFilters (body, params, category) {
	let url = `${API_BASE_URL}/admin-ext/${category}/${apiEndpoints.fieldFilter}/${params}`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_EXT})
}

export function getAuthorScrappedNames(body) {
	let url = `${API_BASE_URL}/admin-ext/author-scrapped-name`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_EXT})
}

// scrap new publication (AP)
export function scrapPublication(type, body) {
	let url = `${API_BASE_URL}/${ADMIN_CURATE}/${type}`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_CURATE})
}

// add new Publisher (AP)
export function addAdminPublisher (body) {
	let url = `${API_BASE_URL}/admin-ext/publisher`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_EXT})
}

// validate uniquename inside add publisher flow (AP)
export function validateUniqueName (body) {
	let url = `${API_BASE_URL}/admin-ext/check-name-unique`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_EXT})
}

// add publication to authors (AP)
export function addPublicationAuthors (body) {
	let url = `${API_BASE_URL}/${ADMIN_CURATE}/add-authors-publication`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_CURATE})
}

/**
 * add author to publication(AP)
 * @param {*} body 
 */
export function addAuthorPublications (body) {
	let url = `${API_BASE_URL}/${ADMIN_CURATE}/add-publications-author`
	return apiCaller({method: METHOD.POST, url, body, service: ADMIN_CURATE})
}
/**
 * api to get the count of metadata in information portal
 * @param {*} body 
 */
export function getInsightAuthorCount (body) {
	let url = `${API_BASE_URL}/${INSIGHT}/author-count`
	return apiCaller({method: METHOD.POST, url, body, service: INSIGHT})
}

/**
 * api to get the count of metadata in information portal
 * @param {*} body 
 */
export function getInsightPublicationCount (body) {
	let url = `${API_BASE_URL}/${INSIGHT}/publication-count`
	return apiCaller({method: METHOD.POST, url, body, service: INSIGHT})
}

export function verifyShareSource (body) {
	let url = `${API_BASE_URL}/${CURATE_EXT}/sharingConfirmation/${body.id}/${body.type}/${body.key}`
	return apiCaller({method: METHOD.GET, url, service: CURATE_EXT})
}

export function claimRequestConfirmation (body) {
	let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/email-action`
	return apiCaller({method: METHOD.POST, url, body, service: INFORMATION_PORTAL})
}

/*
 * provide twitter login request code and
 * redirect url.
 * */
export function getTwitterLoginRequestCode () {
	let url = `${API_BASE_URL}/${TWITTER}/${apiEndpoints.getTwitterLoginRequestCode}`
	return apiCaller({method: 'GET', url, service: TWITTER})
}
  
  /*
   * get user pocket account
   * @params {number} articleId
   * */
export function getSyncedTwitterAccount (params) {
	let url = `${API_BASE_URL}/${TWITTER}/${apiEndpoints.socialAccounts}`
	return apiCaller({method: 'GET', url, params, service: TWITTER})
}

/**
 * twitterAuth - to verify twitter account 
 */
export function verifyTwitterAuth (body) {
	let url = `${API_BASE_URL}/${TWITTER}/access_token`
	return apiCaller({method: METHOD.POST, url, body, service: TWITTER})
}

/**
 * to get code and url from fb
 */
export function getFacebookCode () {
	let url = `${API_BASE_URL}/${FACEBOOK}/code-url`
	return apiCaller({method: METHOD.GET, url, service: FACEBOOK})
}

export function verifyFacebookAuth (body) {
	let url = `${API_BASE_URL}/${FACEBOOK}/access-token`
	return apiCaller({method: METHOD.POST, body, url, service: FACEBOOK})
}

/**
 * get fb accounts
 */
export function getFacebookAccounts () {
	let url = `${API_BASE_URL}/${FACEBOOK}/${apiEndpoints.socialAccounts}`
	return apiCaller({method: METHOD.GET, url, service: FACEBOOK})
}

/**
 * to get the short url of the pages A/P/P 
 * on admin portal
 * (body) -> type of metadata and category
 */
export function getShortUrl (body) {
	let url = `${API_BASE_URL}/${SHORT}/short-url`
	return apiCaller({method: METHOD.POST, url, body, service: SHORT_URL})
}

/**
 * api to hit short url and on response it will 
 * be redirected to appropriate page from backend
 * id - of the page to be redirected on
 */
export function getFullUrl (id, headerToBeAdded) {
	let url = `${API_BASE_URL}/${SHORT}/${id}`
	return apiCaller({method: METHOD.GET, url, service: SHORT_URL, headerToBeAdded})
} 

export function shortServiceBulkUpload (payload) {
	let url = `${API_BASE_URL}/${SHORT}/bulk-update/short-url`
	return apiCaller({method: METHOD.POST, url, body:payload, service: SHORT_URL})
} 

/**
 * to get the contnent url list on publication(AP)
 * @param {*} body contains id of publication
 */
export function getPublicationContentList (body) {
	let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.getList}`
	return apiCaller({method: METHOD.POST, url, body, service: PUBLICATION})
}

/**
 * to update the publication listing record(AP)
 * @param {*} body 
 */
export function updatePublicationContentList (body, id) {
	let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.getContent}/${id}`
	return apiCaller({method: METHOD.PUT, url, body, service: PUBLICATION})
}

/**
 * to create the publication listing record(AP)
 * @param {*} body 
 */
export function createPublicationContentList (body) {
	let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.getContent}`
	return apiCaller({method: METHOD.POST, url, body, service: PUBLICATION})
}

/**
 * to delete the publication content url(AP)
 * @param {*} id of content
 */
export function removePublicationContentList (id) {
	let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.getContent}/${id}`
	return apiCaller({method: METHOD.DELETE, url, service: PUBLICATION})
}

export function bulkUpdatePublicationContentList (body) {
	let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.getContents}`
	return apiCaller({method: METHOD.PUT, url, body, service: PUBLICATION})
}

/** 
* to get the list of collection
*/
export function getCollectionList (body, params) {
	let url = `${API_BASE_URL}/${COLLECTION}/${apiEndpoints.getAllFollowingList}`
	return apiCaller({method: METHOD.POST, url, body, params, service: COLLECTION})
}

/**
 * to get the list of dossier
 */
export function getDossierList (body) {
	let url = `${API_BASE_URL}/${ANALYTICS_MANUAL}/regular-dossiers`
	return apiCaller({method: METHOD.POST, url, body, service: ANALYTICS_MANUAL})
}

/**
 * to get the count of articles on profile page of A/P/P
 */
export function getArticlesCount (body) {
	let url = `${API_BASE_URL}/${USER}/${apiEndpoints.totalCount}`
	return apiCaller({method: METHOD.POST, url, body, service: USER})
}

/**
 * to get the lst of articles on profile page of PUBLICATION
 */
export function getPublicationArticlesList (params, body) {
	let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.articles}`
	return apiCaller({'method': 'POST', url, params, body, service: PUBLICATION})
}

/**
 * to get the lst of articles on profile page of AUTHOR
 */
export function getAuthorArticlesList (params, body) {
	let url = `${API_BASE_URL}/${AUTHOR}/${apiEndpoints.articles}`
	return apiCaller({'method': 'POST', url, params, body, service: AUTHOR})
}

/**
 * to get the lst of articles on profile page of AUTHOR
 */
export function getPublisherArticlesList (params, body) {
	let url = `${API_BASE_URL}/${PUBLISHER}/${apiEndpoints.articles}`
	return apiCaller({'method': 'POST', url, params, body, service: PUBLISHER})
}

/**
 * get the dossier list on A/P/P pages
 */
export function getMetaDossierList (body, params) {
  let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.dossiers}`
  return apiCaller({'method': 'POST', url, params, body, service: PUBLICATION})
}

/**
 * get the dossier list on A/P/P pages
 */
export function getMetaCollectionList (body, params) {
  let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.collections}`
  return apiCaller({'method': 'POST', url, params, body, service: PUBLICATION})
}

/**
 * get collections/dossiers count on A/P/P pages
 */
export function getCollectionDossierCount (body) {
  let url = `${API_BASE_URL}/${USER}/cd-count`
  return apiCaller({'method': 'POST', url, body, service: USER})
}

/**
 * to get the article detail listing of collection
 * @param {*} body 
 */
export function getCollectionDetail (body, params) {
  let url = `${API_BASE_URL}/${COLLECTION}/${apiEndpoints.collectionDetail}`
  return apiCaller({'method': 'POST', url, params, body, service: COLLECTION})
}

/**
 * to get the article detail listing of dossier
 * @param {*} body 
 */
export function getDossierDetail (body, params) {
  let url = `${API_BASE_URL}/${DOSSIER}/${apiEndpoints.dossierDetail}`
  return apiCaller({'method': 'POST', url, params, body, service: DOSSIER})
}

/**
 * to remove the social linked account
 */
export function removeSocialLink (body) {
  let url = `${API_BASE_URL}/${SOCIAL}/${apiEndpoints.remove}`
  return apiCaller({'method': 'POST', url, body, service: SOCIAL})
}

/**
 * to check if subscription of twitter account exists in documents
 * @param {*} body 
 */
export function checkSubscription (body) {
  let url = `${API_BASE_URL}/${TWITTER}/${apiEndpoints.checkSubscription}`
  return apiCaller({'method': METHOD.POST, url, body, service: TWITTER})
}

/**
 * function to get the A/P/P details of collection
 */
export function collectionFilterData (body) {
  let url = `${API_BASE_URL}/${COLLECTION}/${apiEndpoints.collectionFilter}`
  return apiCaller({'method': METHOD.POST, url, body, service: COLLECTION})
}

/**
 * to get the info about collection
 * @param {*} id 
 */
export function getCollectionInfo (id) {
  let url = `${API_BASE_URL}/${COLLECTION}/${id}`
  return apiCaller({'method': METHOD.GET, url, service: COLLECTION})
}

/**
 * api to get the A/P/P details of dossier
 */
export function dossierFilterData (body) {
  let url = `${API_BASE_URL}/${DOSSIER}/${apiEndpoints.dossierFilter}`
  return apiCaller({'method': METHOD.POST, url, body, service: DOSSIER})
}

/**
 * to get the info about dossier
 * @param {*} id 
 */
export function getDossierInfo (id) {
  let url = `${API_BASE_URL}/${DOSSIER}/${id}`
  return apiCaller({'method': METHOD.GET, url, service: DOSSIER})
}

/**
 * to get the follow meta results
 */
export function getUserFollowingDetails (body) {
  let url = `${API_BASE_URL}/${USER}/${apiEndpoints.followings}`
  return apiCaller({'method': METHOD.POST, url, body, service: USER})
}
/**
 * create shor url
 * @param {*} body
 */
export function createShortUrl (body) {
  let url = `${API_BASE_URL}/${SHORT}/${apiEndpoints.create}`
  return apiCaller({method: METHOD.POST, url, body, service: SHORT_URL})
}

/**
 * to create screen name(slug) for A/P/P
 * @param {*} body 
 */
export function createScreenName (body) {
  let url = `${API_BASE_URL}/${AUTHOR}/${apiEndpoints.slug}`
  return apiCaller({method: METHOD.POST, url, body, service: AUTHOR})
}

/**
 * validate screen name
 */
export function validateScreenName (body) {
  let url = `${API_BASE_URL}/${AUTHOR}/${apiEndpoints.unique}`
  return apiCaller({method: METHOD.POST, url, body, service: AUTHOR})
}

/**
 * to validate the url of publications
 */
export function validatePublicationUrl (body) {
  let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.uniqueUrl}`
  return apiCaller({method: METHOD.POST, url, body, service: PUBLICATION})
}
/**
 * to follow collection/dossier
 * @param {*} body body
 * @param {*} follow follow/unfollow
 */
export function followCollection (body, follow) {
  let url = `${API_BASE_URL}/${DOSSIER}/${follow}`
  return apiCaller({method: METHOD.POST, url, body, service: DOSSIER})
}

/**
 * to get the filter data of publication
 * @param {*} body 
 */
export function getPublicationFilterData (body) {
  let url = `${API_BASE_URL}/${INSIGHT}/${apiEndpoints.publicationFilter}`
  return apiCaller({method: METHOD.POST, url, body, service: INSIGHT})
}

/**
 * to get the filter data of author
 * @param {*} body 
 */
export function getAuthorFilterData (body) {
  let url = `${API_BASE_URL}/${INSIGHT}/${apiEndpoints.authorFilter}`
  return apiCaller({method: METHOD.POST, url, body, service: INSIGHT})
}
/**
 * to get the count of followers
 * @param {*} body 
 */
export function getFollowersCount (body) {
  let url = `${API_BASE_URL}/${DOSSIER}/${apiEndpoints.followersCount}`
  return apiCaller({method: METHOD.POST, url, body, service: DOSSIER})
}
/**
 * to get the count of followers
 * @param {*} body 
 */
export function getUserFollowersCount (body) {
  let url = `${API_BASE_URL}/${DOSSIER}/${apiEndpoints.followersUserCount}`
  return apiCaller({method: METHOD.POST, url, body, service: DOSSIER})
}

/**
 * to synchronise the account(social)
 * @param {*} body 
 */
export function synchroniseAccounts (body) {
  let url = `${API_BASE_URL}/${FACEBOOK}/${apiEndpoints.synchronize}`
  return apiCaller({method: METHOD.POST, url, body, service: FACEBOOK})
}

/**
 * update social accounts
 * @param {*} body 
 */
export function updateSocialAccount (body) {
  let url = `${API_BASE_URL}/${SOCIAL}/${apiEndpoints.update}`
  return apiCaller({method: METHOD.PUT, url, body, service: SOCIAL})
}

/**
 * to get the content feeds publication(AP)
 * @param {*} body 
 */
export function getFeedsOriginList (body) {
  let url = `${API_BASE_URL}/${PUBLICATION}/${apiEndpoints.originList}`
  return apiCaller({method: METHOD.POST, url, body, service: PUBLICATION})
}

/**
 * to get the time ranges for the articles in IP
 */
export function getAuthorTimeRange (path) {
  let url = `${API_BASE_URL}/${AUTHOR}/${apiEndpoints.oldNewRecord}/${path}`
  return apiCaller({method: METHOD.GET, url, service: AUTHOR})
}

/**
 * to create/delete favourite(star)
 * @param {*} body type & id
 * @param {*} path createFavourite/deleteFavourite
 */
export function updateFavourite (body, path) {
  let url = `${API_BASE_URL}/${NEWSROOM}/${path}`
  return apiCaller({method: METHOD.POST, url, body, service: NEWSROOM})
}

/**
 * share on twitter
 * @param {*} body 
 */
export function socialShareTwitter (body) {
  let url = `${API_BASE_URL}/${SOCIAL}/${apiEndpoints.twitter}`
  return apiCaller({'method': METHOD.POST, url, body, service: SOCIAL})
}

/**
 * share on fb
 */
export function socialShareFacebook (body) {
  let url = `${API_BASE_URL}/${SOCIAL}/facebook`
  return apiCaller({method: METHOD.POST, url, body, service: SOCIAL})
}
/**
 * get pages and groups details for fb
 */
export function getPagesAndGroups () {
  let url = `${API_BASE_URL}/${FACEBOOK}/pages-groups`
  return apiCaller({method: METHOD.GET, url, service: FACEBOOK})
}

// to subscribe a accura plan
export function addArticleToAccuraDocuments (body) {
  let url = `${API_BASE_URL}/${CONTENT}/${apiEndpoints.addViaExtension}`;
  return apiCaller({method: METHOD.POST, url, body, service: CONTENT})
}

// api to search metadata on header(NEWSROOM)
export function searchMeta (body) {
  let url = `${API_BASE_URL}/${NEWSROOM}/${apiEndpoints.getList}`;
  return apiCaller({method: METHOD.POST, url, body, service: NEWSROOM})
}

// to update the count of add to document(NEWSROOM)
export function updateAddToCatalogCount (body) {
  let url = `${API_BASE_URL}/${NEWSROOM}/${apiEndpoints.addDocument}`;
  return apiCaller({method: METHOD.POST, url, body, service: NEWSROOM})
}

export function updateShareCount (body, params) {
  let url = `${API_BASE_URL}/${SOCIAL}/${params}`;
  return apiCaller({method: METHOD.POST, url, body, service: SOCIAL})
}

export function embeddableList (params) {
	let url = `${API_BASE_URL}/${EMBEDDABLE}/data`
	return apiCaller({method: METHOD.GET, url, params, service: EMBEDDABLE})
}

// create new organisation
export function createOrganisation (body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/${apiEndpoints.organisation}`
  return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION})
}

// create new organisation
export function updateOrganisation (body, id) {
  let url = `${API_BASE_URL}/${ORGANISATION}/${apiEndpoints.organisation}/${id}`
  return apiCaller({method: METHOD.PUT, url, body, service: ORGANISATION})
}

// get organisation list
export function getOrganisation () {
  let url = `${API_BASE_URL}/${ORGANISATION}/organisations`
  return apiCaller({method: METHOD.GET, url, service: ORGANISATION})
}
/**
 * get organisation details by id
 * @param {*} id id of org.
 */
export function getOganisationById (id) {
  let url = `${API_BASE_URL}/${ORGANISATION}/${apiEndpoints.organisation}/${id}`
  return apiCaller({method: METHOD.GET, url, service: ORGANISATION})
}
// remove organisation
export function removeOrganisation (id) {
  let url = `${API_BASE_URL}/${ORGANISATION}/${apiEndpoints.organisation}/${id}`
  return apiCaller({method: METHOD.DELETE, url, service: ORGANISATION})
}

// leave organisation
export function leaveOrganisation (id, body) {
	let url = `${API_BASE_URL}/${ORGANISATION}/leave/${id}`
	return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION})
  }

// to get the team list
export function getOrganisationsTeam (body, params) {
  let url = `${API_BASE_URL}/${TEAM}/teams`
  return apiCaller({method: METHOD.POST, url, body, params, service: TEAM})
}
// create team 
export function createOrganisationTeam (body) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.team}`
  return apiCaller({method: METHOD.POST, url, body, service: TEAM})
}
// delete team
export function deleteOrganisationTeam (id, body) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.team}/${id}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
} 
// get team details by id
export function getTeamById (id) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.team}/${id}`
  return apiCaller({method: METHOD.GET, url, service: TEAM})
}
// update teams
export function updateTeam (body, id) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.team}/${id}`
  return apiCaller({method: METHOD.PUT, body, url, service: TEAM})
}

/**
 * remove member from team
 * @param {*} body 
 */
export function removeMemberFromTeam (body) {
  let url = `${API_BASE_URL}/${TEAM}/remove-member`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}

/**
 * step 1 for inviting member in organisation people
 * @param {*} body 
 */
export function validateMemberToOrganisation (body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/invite-step1`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION})
}

/**
 * step 2 for inviting member in organisation people
 * @param {*} body 
 */
export function inviteMemberToOrganisation (body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/invite-step2`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION})
}

/**
 * step 1 for inviting member in organisation people
 * @param {*} body 
 */
export function validateMemberToTeam (body) {
  let url = `${API_BASE_URL}/${TEAM}/invite-step1`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}
  
  /**
   * step 2 for inviting member in organisation people
   * @param {*} body 
   */
export function inviteMemberToTeam (body) {
  let url = `${API_BASE_URL}/${TEAM}/invite-step2`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}

/**
 * to get the list of people in organisation
 */
export function getPeopleList (body, params) {
  let url = `${API_BASE_URL}/${PEOPLE}/peoples`
  return apiCaller({method: METHOD.POST, body, url, params, service: PEOPLE})
}

/**
 * to get the list of members of team
 * @param {*} body 
 */
export function getMembersByTeam (body, params) {
  let url = `${API_BASE_URL}/${TEAM}/members`
  return apiCaller({method: METHOD.POST, body, params, url, service: TEAM})
}

export function getUserSuggestions (body) {
  let url = `${API_BASE_URL}/${USER}/${apiEndpoints.getList}`
  return apiCaller({method: METHOD.POST, body, url, service: USER})
}

/**
 * email verify people
 */
export function emailVerifyPeople (body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/${apiEndpoints.emailAction}`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION})
}

/**
 * email verify team
 */
export function emailVerifyTeam (body) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.emailAction}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}
/**
 * invite Count people
 * @param {*} body 
 */
export function inviteCount (body) {
  let url = `${API_BASE_URL}/${PEOPLE}/count`
  return apiCaller({method: METHOD.POST, body, url, service: PEOPLE})
}

/**
 * invite Count team members of ORG
 * @param {*} body 
 */
export function inviteTeamMemberCount (body) {
  let url = `${API_BASE_URL}/${TEAM}/count`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}

/**
 * FILTER api for org people
 * @param {*} body 
 */
export function peopleFieldFilter (body, params) {
  let url = `${API_BASE_URL}/${PEOPLE}/${apiEndpoints.people}/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, params, service: PEOPLE})
}

/**
 * to get the filter data for collab pending list
 */
export function pendingCollabFieldFilter (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/pending/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * to get the filter data for people pending list
 */
export function pendingPeopleFieldFilter (body) {
  let url = `${API_BASE_URL}/${PEOPLE}/pending/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, service: PEOPLE})
}

/**
 * to get the filter data for failed people list
 */
export function failedPeopleFieldFilter (body) {
  let url = `${API_BASE_URL}/${PEOPLE}/failed/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, service: PEOPLE})
}

/**
 * FILTER api for org team
 * @param {*} body 
 */
export function teamFieldFilter (body, params) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.team}/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, params, service: TEAM})
}

/**
 * to get the pending people list
 */
export function getPendingPeopleList (body, params) {
  let url = `${API_BASE_URL}/${PEOPLE}/${apiEndpoints.pendingInvitationList}`
  return apiCaller({method: METHOD.POST, body, params, url, service: PEOPLE})
}

/**
 * to cancel the people invitation to an organisation
 */
export function cancelInvitation (body) {
  let url = `${API_BASE_URL}/${PEOPLE}/${apiEndpoints.cancelInvitation}`
  return apiCaller({method: METHOD.POST, body, url, service: PEOPLE})
}

/**
 * to cancel the collaborator invitation to an organisation/team
 */
export function cancelCollaboratorInvitation (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/${apiEndpoints.cancelInvitation}`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * to update the people invitation
 */
export function updateInvitation (body, id) {
  let url = `${API_BASE_URL}/${PEOPLE}/invitation/${id}`
  return apiCaller({method: METHOD.PUT, body, url, service: PEOPLE})
}

/**
 * to update the people invitation
 */
export function getFailedPeopleList (body, params) {
  let url = `${API_BASE_URL}/${PEOPLE}/${apiEndpoints.failedInvitationList}`
  return apiCaller({method: METHOD.POST, body, params, url, service: PEOPLE})
}

/**
 * step 1 for inviting member in organisation people
 * @param {*} body 
 */
export function validateBillingManagerToOrganisation (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/invite-step1`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * step 2 for inviting member in organisation people
 * @param {*} body 
 */
export function inviteBillingManagerToOrganisation (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/invite-step2`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * email verify billing manager
 */
export function emailVerifyBillingManager (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/${apiEndpoints.emailAction}`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the mention list
 * @param {*} body body for api
 */
export function getMentionList (body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/mention`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function getMentionCardDetail (body) {
  let url = `${API_BASE_URL}/${PEOPLE}/card-detail`
  return apiCaller({method: METHOD.POST, body, url, service: PEOPLE})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function getPaymentList (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/${apiEndpoints.paymentMethod}s`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function addOganisationPayment (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/${apiEndpoints.paymentMethod}`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function removeOganisationPayment (id, body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/${apiEndpoints.paymentMethod}/${id}`
  return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION_BILLING})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function getOrgSubscriptionsList (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/subscriptions`
  return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION_BILLING})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function changeDefaultOrgPayment (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/default-payment-method`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the mention card detail
 * @param {*} body body
 */
export function getInvoicesList (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/invoices`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to fetch the details of screen names
 */
export function getScreenNameDetails (body) {
  let url = `${API_BASE_URL}/${PEOPLE}/screen-names`
  return apiCaller({method: METHOD.POST, body, url, service: PEOPLE})
}

/**
 * to get the list of billing manager of org
 * @param {*} body 
 */
export function getBillingManagerList (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/billing-managers`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the list of billing manager of org
 * @param {*} body 
 */
export function removeBillingManager (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/remove`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the list of billing manager of org
 * @param {*} body 
 */
export function updateBillingCustomer (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/update`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the list of billing manager of org
 * @param {*} body 
 */
export function getBillingCustomer (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_BILLING}/address-vat`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_BILLING})
}

/**
 * to get the list of eligible donations
 */
export function getEligibleDonations () {
  let url = `${API_BASE_URL}/${DONATION}/eligible`
  return apiCaller({method: METHOD.GET, url, service: DONATION})
}

/**
 * to create connected account in stripe
 */
export function createConnectedAccount (body) {
  let url = `${API_BASE_URL}/${DONATION}/connected-account`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * to update connected account in stripe
 */
export function updateConnectedAccount (body) {
  let url = `${API_BASE_URL}/${DONATION}/connected-account`
  return apiCaller({method: METHOD.PUT, body, url, service: DONATION})
}

/**
 * to create connected account in stripe
 */
export function createLoginStripeLink (body) {
  let url = `${API_BASE_URL}/${DONATION}/login-link`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * to create connected account in stripe
 */
export function checkStripeAccountStatus (body) {
  let url = `${API_BASE_URL}/${DONATION}/account-status`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * to create payment intent for donation(stripe)
 */
export function createDonationPaymentIntent (body) {
  let url = `${API_BASE_URL}/${DONATION}/payment-intent`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * to create payment method for donation(stripe)
 */
export function confirmDonationPaymentIntent (body) {
  let url = `${API_BASE_URL}/${DONATION}/confirm-payment-intent`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}
/**
 * to create monthly subscription (donation)
 */
 export function monthlyDonationSubscription (body) {
  let url = `${API_BASE_URL}/${DONATION}/monthly-subscription`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * to update the donation profile info(stripe)
 */
export function updateDonationProfile (body) {
  let url = `${API_BASE_URL}/${DONATION}/profile`
  return apiCaller({method: METHOD.PUT, body, url, service: DONATION})
}

/**
 * step 1 for inviting collaborator in team collection
 * @param {*} body 
 */
export function validateCollaboratorToTeam (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/invite-step1`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * step 2 for inviting collaborator in team collection
 * @param {*} body 
 */
export function inviteCollaboratorToTeam (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/invite-step2`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * email verify collaborator
 */
export function emailVerifyCollaborator (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/${apiEndpoints.emailAction}`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * to get collaborator list
 */
export function getCollaboratorsList (body, params) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/collaborators`
  return apiCaller({method: METHOD.POST, body, params, url, service: COLLABORATORS})
}

/**
 * to change role collaborator
 */
export function changeCollaboratorRole (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/${apiEndpoints.changeRole}`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * to change role team member
 */
export function changeTeamMemberRole (body) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.changeRole}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}

/**
 * to change role ORG people
 */
export function changeOrganisationPeopleRole (body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/${apiEndpoints.changeRole}`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION})
}

/**
 * to remove the collaborators
 */
export function removeCollaborator (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/${apiEndpoints.remove}`
  return apiCaller({method: METHOD.POST, body, url, service: COLLABORATORS})
}

/**
 * to get the collaborator list
 */
export function getCollaboratorList (body, params) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/${apiEndpoints.pendingInvitationList}`
  return apiCaller({method: METHOD.POST, body, params, url, service: COLLABORATORS})
}

/**
 * to get team total count
 */
export function getTeamTotalCount (body) {
  let url = `${API_BASE_URL}/${TEAM}/${apiEndpoints.totalCount}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}

/**
 * to get team members field filter
 */
export function memberFieldFilter (body) {
  let url = `${API_BASE_URL}/${TEAM}/member/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM})
}

/**
 * to get failed team members field filter
 */
export function failedMemberFieldFilter (body) {
  let url = `${API_BASE_URL}/${TEAM_EXTENSION}/failed/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM_EXTENSION})
}

/**
 * to get pending team members field filter
 */
export function pendingMemberFieldFilter (body) {
  let url = `${API_BASE_URL}/${TEAM_EXTENSION}/pending/${apiEndpoints.fieldFilter}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM_EXTENSION})
}

/**
 * to get failed team members invitation list
 */
export function failedTeamMemberList (body, params) {
  let url = `${API_BASE_URL}/${TEAM_EXTENSION}/${apiEndpoints.failedInvitationList}`
  return apiCaller({method: METHOD.POST, body, params, url, service: TEAM_EXTENSION})
}

/**
 * to get failed team members invitation list
 */
export function pendingTeamMemberList (body, params) {
  let url = `${API_BASE_URL}/${TEAM_EXTENSION}/${apiEndpoints.pendingInvitationList}`
  return apiCaller({method: METHOD.POST, body, params, url, service: TEAM_EXTENSION})
}

/**
 * to get cancel invite team member
 */
export function cancelTeamMemberInvitation (body) {
  let url = `${API_BASE_URL}/${TEAM_EXTENSION}/${apiEndpoints.cancelInvitation}`
  return apiCaller({method: METHOD.POST, body, url, service: TEAM_EXTENSION})
}

/**
 * to get role an permissions of team and organisation
 */
export function getRolesAndPermissions (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_PERMISSIONS}/permissions`
  return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION_PERMISSIONS})
}

/**
 * to get role an permissions of team and organisation
 */
export function getTeamPermissions () {
  let url = `${API_BASE_URL}/${ORGANISATION_PERMISSIONS}/team-permissions`
  return apiCaller({method: METHOD.GET, url, service: ORGANISATION_PERMISSIONS})
}

/**
 * to search for the members of the team in invite screen
 * @param {*} body 
 */
export function teamMemberSearchList (body) {
  let url = `${API_BASE_URL}/${TEAM_EXTENSION}/${apiEndpoints.getList}`
  return apiCaller({method: METHOD.POST, url, body, service: TEAM_EXTENSION})
}

/**
 * to search for the collaborators in the first screen of invite
 * @param {*} body 
 */
export function collaboratorSearchList (body) {
  let url = `${API_BASE_URL}/${COLLABORATORS}/${apiEndpoints.getList}`
  return apiCaller({method: METHOD.POST, url, body, service: COLLABORATORS})
}

/**
 * to search for the collaborators in the first screen of invite
 * @param {*} body 
 */
export function createDonationTier (body) {
  let url = `${API_BASE_URL}/${DONATION}/${apiEndpoints.donationTier}`
  return apiCaller({method: METHOD.POST, url, body, service: DONATION})
}

/**
 * to search for the collaborators in the first screen of invite
 * @param {*} body 
 */
export function updateDonationTier (body) {
  let url = `${API_BASE_URL}/${DONATION}/${apiEndpoints.donationTier}`
  return apiCaller({method: METHOD.PUT, url, body, service: DONATION})
}

/**
 * to search for the collaborators in the first screen of invite
 * @param {*} body 
 */
export function getDonationTier (body) {
  let url = `${API_BASE_URL}/${DONATION}/${apiEndpoints.getList}/${apiEndpoints.donationTier}`
  return apiCaller({method: METHOD.POST, url, body, service: DONATION})
}

/**
 * to search for the collaborators in the first screen of invite
 * @param {*} body 
 */
export function deleteDonationTier (body) {
  let url = `${API_BASE_URL}/${DONATION}/delete/${apiEndpoints.donationTier}`
  return apiCaller({method: METHOD.POST, url, body, service: DONATION})
}

/**
 * to get the payment option in donate dialog popup
 */
export function listPaymentMethod (body) {
  let url = `${API_BASE_URL}/${PAYMENT}/payment-method`
  return apiCaller({method: METHOD.POST, body, url, service: PAYMENT})
}

/**
 * to add feature work in donation
 * @param {*} body 
 */
export function addFeatureWork (body) {
  let url = `${API_BASE_URL}/${DONATION}/${apiEndpoints.featureWork}`
  return apiCaller({method: METHOD.POST, url, body, service: DONATION})
}

/**
 * to update feature work in donation
 * @param {*} body 
 */
export function updateFeatureWork (body) {
  let url = `${API_BASE_URL}/${DONATION}/${apiEndpoints.featureWork}`
  return apiCaller({method: METHOD.PUT, url, body, service: DONATION})
}

/**
 * to update feature work in donation
 * @param {*} body 
 */
export function getDonarProfile (body) {
  let url = `${API_BASE_URL}/${DONATION}/donation-profile`
  return apiCaller({method: METHOD.POST, url, body, service: DONATION})
}

/**
 * to update feature work in donation
 * @param {*} body 
 */
export function getStripeAccountDetail (body) {
  let url = `${API_BASE_URL}/${DONATION}/stripe-account-detail`
  return apiCaller({method: METHOD.POST, url, body, service: DONATION})
}

/**
 * to get the organisation list without collaborators
 * to show it in profile
 */
export function organisationWithoutCollab () {
  let url = `${API_BASE_URL}/${ORGANISATION}/profile-change`
  return apiCaller({method: METHOD.GET, url, service: ORGANISATION})
}

/**
 * to get the organisation list without collaborators
 * to show it in profile
 */
export function generateToken (body) {
  let url = `${API_BASE_URL}/${ACCOUNT}/generate-token`
  return apiCaller({method: METHOD.POST, body, url, service: ACCOUNT})
}

export function verifyDomainDns(body){
  let url = `${API_BASE_URL}/${DOMAIN}/${apiEndpoints.verifyDomainDns}`
  return apiCaller({method: METHOD.POST, body, url, service: DOMAIN})
}

export function verifyHtmlFile(body){
  let url = `${API_BASE_URL}/${DOMAIN}/${apiEndpoints.verifyHtmlFile}`
  return apiCaller({method: METHOD.POST, body, url, service: DOMAIN})
}

export function verifyMetaTag(body){
  let url = `${API_BASE_URL}/${DOMAIN}/${apiEndpoints.verifyMetaTag}`
  return apiCaller({method: METHOD.POST, body, url, service: DOMAIN})
}

export function getDomainList(body){
  let url = `${API_BASE_URL}/${DOMAIN}/${apiEndpoints.getDomainList}`
  return apiCaller({method:METHOD.POST,body,url,service:DOMAIN})
}

export function addDomain(body){
  let url = `${API_BASE_URL}/${DOMAIN}/${apiEndpoints.addDomain}`
  return apiCaller({method:METHOD.POST,body,url,service:DOMAIN})
}

export function deleteDomain (body) {
  let url = `${API_BASE_URL}/${DOMAIN}/${body.organisation_id}/${body.domain_id}`
  return apiCaller({method: METHOD.DELETE, body, url, service: DOMAIN})
}

/**
 * Update Domain
 */
 export function updateDomain (payload, body) {
  let url = `${API_BASE_URL}/${DOMAIN}/${payload.organisation_id}/${payload.domain_id}`
  return apiCaller({method: METHOD.PUT, body, url, service: DOMAIN})
}

/**
 * add location
 */
export function addLocation (body) {
  let url = `${API_BASE_URL}/${LOCATION}/location`
  return apiCaller({method: METHOD.POST, body, url, service: LOCATION})
}

/**
 * location - types
 */
 export function locationTypes (entityType) {
  let url = `${API_BASE_URL}/${LOCATION}/types/${entityType}`
  return apiCaller({method: METHOD.GET, url, service: LOCATION})
}

/**
 * location - list for entities
 */
 export function locationListForEntity (entityId, body) {
  let url = `${API_BASE_URL}/${LOCATION}/list/${entityId}`
  return apiCaller({method: METHOD.POST, body, url, service: LOCATION})
}

/**
 * delete location
 * @param {*} id 
 * @returns 
 */
export function deleteLocation (id) {
  let url = `${API_BASE_URL}/${LOCATION}/${id}`
  return apiCaller({method: METHOD.DELETE, url, service: LOCATION})
}

/**
 * get detail of single location location
 * @param {*} id 
 * @returns 
 */
 export function getLocationDetail (id) {
  let url = `${API_BASE_URL}/${LOCATION}/${id}`
  return apiCaller({method: METHOD.GET, url, service: LOCATION})
}

/**
 * update detail of single location location
 * @param {*} id 
 * @returns 
 */
 export function updateLocationDetail (id, body) {
  let url = `${API_BASE_URL}/${LOCATION}/${id}`
  return apiCaller({method: METHOD.PUT, body, url, service: LOCATION})
}

/**
 * manage location tree (drag/drop)
 * @param {*} body 
 * @returns 
 */
export function manageLocationTree (body) {
  let url = `${API_BASE_URL}/${LOCATION}/tree`
  return apiCaller({method: METHOD.POST, body, url, service: LOCATION})
}

/**
 * to manage seats of org
 * @returns
 */
export function managePeopleSeats (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_LICENSE}/manage-license`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_LICENSE})
}

/**
 * to get the count of org seats
 * @returns
 */
export function getManageSeatsCount (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_PERMISSIONS}/license-count`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_PERMISSIONS})
}

/**
 * to get plan list
 */
export function getOrgPlanList (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_LICENSE}/plans`
  return apiCaller({method: METHOD.POST, body, url, service: ORGANISATION_LICENSE})
}

/**
 * to change organistation paln
 */
 export function changeOrgPlan (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_LICENSE}/plan`
  return apiCaller({method: METHOD.PUT, body, url, service: ORGANISATION_LICENSE})
}

/**
 * to get the short urls archived and active for org
 */
 export function getActiveArchivedShortUrls (body,params) {
  let url = `${API_BASE_URL}/${SHORT}/org-url-list${params}`
  return apiCaller({method: METHOD.POST, body, url, service: SHORT_URL})
}

/**
 * create reporting groups
 */
 export function createReportingGroups (body) {
  let url = `${API_BASE_URL}/${SHORT}/reporting-group`
  return apiCaller({method: METHOD.POST, body, url, service: SHORT_URL})
}

/**
 * update reporting groups
 */
 export function updateReportingGroups (body, id) {
  let url = `${API_BASE_URL}/${SHORT}/reporting-group/${id}`
  return apiCaller({method: METHOD.PUT, body, url, service: SHORT_URL})
}

/**
 * get reporting groups list
 */
 export function getReportingGroups (body) {
  let url = `${API_BASE_URL}/${SHORT}/reporting-group-list`
  return apiCaller({method: METHOD.POST, body, url, service: SHORT_URL})
}

/**
 * get org url count
 */
 export function organisationUrlCount (body) {
  let url = `${API_BASE_URL}/${SHORT}/url-count`
  return apiCaller({method: METHOD.POST, body, url, service: SHORT_URL})
}

/**
 * get org short url by Id
 */
 export function getShortUrlById (shortUrlId) {
  let url = `${API_BASE_URL}/${SHORT}/short-url/${shortUrlId}`
  return apiCaller({method: METHOD.GET, url, service: SHORT_URL})
}

/**
 * update short url
 * @param {*} body 
 * @returns 
 */
 export function updateShortUrl (body, id) {
  let url = `${API_BASE_URL}/${SHORT}/url/${id}`
  return apiCaller({method: METHOD.PUT, body, url, service: SHORT_URL})
}

/**
 * create donation set
 */
export function createDonationSet (body) {
  let url = `${API_BASE_URL}/${DONATION}/donation-set`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * update donation set
 */
 export function updateDonationSet (body, setId) {
  let url = `${API_BASE_URL}/${DONATION_EXT}/donation-set/${setId}`
  return apiCaller({method: METHOD.PUT, body, url, service: DONATION_EXT})
}

/**
 * create donation set
 */
 export function removeDonationSet (body) {
  let url = `${API_BASE_URL}/${DONATION}/delete/donation-set`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * getDoantion list
 */
 export function getDonorsList (body) {
  let url = `${API_BASE_URL}/${DONATION}/donors`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION})
}

/**
 * getDoantion list
 */
 export function getStripeCustomer (body) {
  let url = `${API_BASE_URL}/${DONATION_EXT}/customer`
  return apiCaller({method: METHOD.POST, body, url, service: DONATION_EXT})
}

/**
 * Account Delete API
 */
 export function accountDeletePermanently (userId) {
  let url = `${API_BASE_URL}/${ACCOUNT}/account/${userId}`
  return apiCaller({method: METHOD.DELETE, url, service: ACCOUNT})
}

/**
 * get User delete email
 */
 export function getDeleteUserEmail () {
  let url = `${API_BASE_URL}/${USER}/delete-email`
  return apiCaller({method: METHOD.GET, url, service: USER})
}

/**
 * fetch only admin organisations
 */
 export function getOnlyAdminOrganisations (body) {
  let url = `${API_BASE_URL}/${ORGANISATION_LICENSE}/only-admin`
  return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION_LICENSE})
}

/**
 * merge scrapped name in admin portal
 * @param {*} body 
 */
export function mergeScrappedName (body) {
  let url = `${API_BASE_URL}/${ADMIN_CURATE}/merge-scrapped-name`
  return apiCaller({method: METHOD.POST, url, body, service: ADMIN_CURATE})
}

/**
 * add Short URL reporting groups
 */
 export function createReportingGroup (body) {
	let url = `${API_BASE_URL}/${SHORT}/reporting-group`
	return apiCaller({method: METHOD.POST, url, body, service: SHORT_URL})
}

/**
 * update short URL reporting groups
 */
 export function updateReportingGroup (body, group_id) {
	let url = `${API_BASE_URL}/${SHORT}/reporting-group/${group_id}`
	return apiCaller({method: METHOD.PUT, url, body, service: SHORT_URL})
}

/**
 * to verify if the domain is reachable
 * @param {*} body 
 */
export function isUrlReachable (body) {
  let url = `${API_BASE_URL}/${DOMAIN}/is-reachable`
	return apiCaller({method: METHOD.POST, url, body, service: DOMAIN})
}

/**
 * get country list API
 * @returns country list
 */
export function getCountryList () {
  let url = `${API_BASE_URL}/${INSIGHT}/country`
	return apiCaller({method: METHOD.GET, url, service: INSIGHT})
}

/**
 * get country list API
 * @returns country list
 */
 export function getStateList (countryId) {
  let url = `${API_BASE_URL}/${INSIGHT}/state/${countryId}`
	return apiCaller({method: METHOD.GET, url, service: INSIGHT})
}

//------------------------------******--Iam Dasboard API Functions--******------------------------------

export function getIamUsersForUser(org,params , body){
  let url = `${API_BASE_URL}/${IAM}/iam/get-all-users/${org}${params}`
  return apiCaller({method: METHOD.POST, url, body,service: IAM})
}

export function getIamgUserGroupsList(orgID ,params , body){
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.getuserGroups}/${orgID}${params}`
	return apiCaller({method: METHOD.POST, url,body , service: IAM})
}

export function getIamUsers(orgID , params ,body){
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.getAllUsers}/${orgID}${params}`
	return apiCaller({method: METHOD.POST, url, body, service: IAM})
}
export function getIamPermissionsForGroup(){
}
export function createUserGroup(body){
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.createUsergroup}`
	return apiCaller({method: METHOD.POST, url, body,service: IAM}) 
}
export function editUserGroup(groupId, body){
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.editUserGroup}/${groupId}`
	return apiCaller({method: METHOD.POST, url, body,service: IAM}) 
}
export function deleteUserGroup(groupId){
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.deleteUserGroup}/${groupId}`
	return apiCaller({method: METHOD.POST, url,service: IAM}) 
}
export function getGroupDetailById(groupId){
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.getGroupDetailById}/${groupId}`
	return apiCaller({method: METHOD.GET, url,service: IAM}) 
}
export function userBulkEdit (payload) {
	let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.bulkEditUser}`
	return apiCaller({method: METHOD.PUT, url, body:payload, service: IAM})
} 
export function userGroupBulkEdit (payload) {
	let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.bulkEditUserGroup}`
	return apiCaller({method: METHOD.PUT, url, body:payload, service: IAM})
} 
export function getUserPermissions () {
  let url = `${API_BASE_URL}/${IAM}/${apiEndpoints.userPermissions}`
  return apiCaller({method: METHOD.GET, url, service: IAM})
}
export function getPermissionPolicies (body) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/${apiEndpoints.getPermissionPolicies}`
  return apiCaller({method: METHOD.POST, url, body, service: IAM_PERMISSIONS})
}
export function getUserInvoiceList (params, body) {
  let url = `${API_BASE_URL}/${ADMIN}/invoice-list/${params}`
  return apiCaller({method: METHOD.POST, url, body, service: ADMIN})
}
export function createIamRole (body) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/create-role`
  return apiCaller({method: METHOD.POST, url, body, service: IAM_PERMISSIONS})
}
export function getIamRole (orgId, params, body) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/get-iam-role/${orgId}/${params}`
  return apiCaller({method: METHOD.POST, url, body, service: IAM_PERMISSIONS})
}
export function updateIamRole (body) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/update-iam-role`
  return apiCaller({method: METHOD.POST, url, body, service: IAM_PERMISSIONS})
}
export function deleteIamRole (orgId, roleId) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/delete-iam-role/${roleId}/${orgId}`
  return apiCaller({method: METHOD.DELETE, url, service: IAM_PERMISSIONS})
}
export function getPermissionsList (params, body) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/permission-list/${params}`
  return apiCaller({method: METHOD.POST, url, body, service: IAM_PERMISSIONS})
}
export function rolesBulkEdit (body) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/bulk-update-iam-role`
  return apiCaller({method: METHOD.POST, url, body, service: IAM_PERMISSIONS})
}
export function copyIamRole (roleId) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/copy-iam-role/${roleId}`
  return apiCaller({method: METHOD.GET, url, service: IAM_PERMISSIONS})
}
export function getSingleIamRole (roleId) {
  let url = `${API_BASE_URL}/${IAM_PERMISSIONS}/view-iam-role/${roleId}`
  return apiCaller({method: METHOD.GET, url, service: IAM_PERMISSIONS})
}
export function getUserGitInfo () {
  let url = `${API_BASE_URL}/${EDITOR}/get-user-git-info`
  return apiCaller({method: METHOD.GET, url, service: EDITOR})
}
export function deleteUserGitInfo(repo_id) {
  let url = `${API_BASE_URL}/${EDITOR}/delete-user-git-info/${repo_id}`
  return apiCaller({method: METHOD.DELETE, url, service: EDITOR})
}
export function addUserGitInfo(body) {
  let url = `${API_BASE_URL}/${EDITOR}/add-user-git-info`
  return apiCaller({method: METHOD.POST, url, body, service: EDITOR})
}
export function addPublicationToOrganisation(body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/add-publication-to-organisation`
  return apiCaller({method: METHOD.POST, url, body, service: ORGANISATION})
}
export function getOrganisationPublicationsList(organisation_id) {
  let url = `${API_BASE_URL}/${ORGANISATION}/list-of-publication/${organisation_id}`
  return apiCaller({method: METHOD.GET, url, service: ORGANISATION})
}
export function removePublicationFromOrganisation(organisation_id, publication_id) {
  let url = `${API_BASE_URL}/${ORGANISATION}/remove-publication-from-organisation/${organisation_id}/${publication_id}`
  return apiCaller({method: METHOD.DELETE, url, service: ORGANISATION})
}
export function refreshOrigin(origin_id) {
  let url = `${API_BASE_URL}/${PUBLICATION}/refresh-origin/${origin_id}`
  return apiCaller({method: METHOD.GET, url, service: PUBLICATION})
}
export function getArticleFollowCount(type, body) {
  let url = `${API_BASE_URL}/${INFORMATION_PORTAL}/get-article-count/${type}`
  return apiCaller({method: METHOD.POST, url, body, service: INFORMATION_PORTAL})
}
export function getUserWithoutRole(id, body) {
  let url = `${API_BASE_URL}/${ORGANISATION}/get-user-without-role/${id}`;
  return apiCaller({ method: METHOD.POST, url, body, service: ORGANISATION});
}